module.exports = __webpack_public_path__ + "static/media/qrs_bg_sessions.1b9d4220.jpg";